// https://vuex.vuejs.org/en/state.html

export default {
  //
  debug: true,
  loading: false,
  isLogged: false,

  notifyMessage: null,
  notifyTimeout: 3000,
  menuControl: false,

  firebaseUser: null,
  uid: null,
  email: null,
  displayName: null,
  level: 0,

  allProducts: [],
  thisOrder: [],
}
